import { createSlice } from '@reduxjs/toolkit'

export const NotesStore = createSlice({
    name: 'notes',
    initialState: {
        filter: null,
        currentNoteId: null,
        notesCounter: []
    },
    reducers: {
        setNotesFilter: (state, payloadAction) => {
            state.filter = payloadAction.payload;
        },
        setCurrentNoteId: (state, payloadAction) => {
            state.currentNoteId = payloadAction.payload;
        },
        setNotesCounter: (state, payloadAction) => {
            state.notesCounter = payloadAction.payload;
        },
    },
})

// Action creators are generated for each case reducer function
export const { setNotesFilter, setCurrentNoteId, setNotesCounter } = NotesStore.actions

export default NotesStore.reducer